import { lazy, Suspense, useEffect, useState } from "react";
import Navigation from "@/components/sections/Navigation";
import Ticker from "@/components/sections/Ticker";
import Hero from "@/components/sections/Hero";
import Calculator from "@/components/sections/Calculator";
import ApplyCTA from "@/components/sections/ApplyCTA";
import Footer from "@/components/sections/Footer";

// Marketing-heavy sections are desktop-only — hidden on mobile to keep things fast and lean.
const FundingProducts = lazy(() => import("@/components/sections/FundingProducts"));
const StatsSection = lazy(() => import("@/components/sections/StatsSection"));
const WhyChooseUs = lazy(() => import("@/components/sections/WhyChooseUs"));
const Industries = lazy(() => import("@/components/sections/Industries"));
const HowItWorks = lazy(() => import("@/components/sections/HowItWorks"));
const Testimonials = lazy(() => import("@/components/sections/Testimonials"));
const ReferralRewardBanner = lazy(() => import("@/components/sections/ReferralRewardBanner"));

// Always lazy on every breakpoint — only loads after the page has settled.
const LiveNotifications = lazy(() => import("@/components/sections/LiveNotifications"));
const ChatWidget = lazy(() => import("@/components/ChatWidget"));

export default function HomePage() {
  const [isDesktop, setIsDesktop] = useState(
    typeof window === "undefined" ? true : window.innerWidth >= 768
  );
  const [floatingsReady, setFloatingsReady] = useState(false);

  useEffect(() => {
    const onResize = () => setIsDesktop(window.innerWidth >= 768);
    window.addEventListener("resize", onResize);
    // Defer Chat + LiveNotifications until after first paint to free up the main thread.
    const t = window.setTimeout(() => setFloatingsReady(true), 1800);
    return () => {
      window.removeEventListener("resize", onResize);
      window.clearTimeout(t);
    };
  }, []);

  return (
    <main className="relative bg-[#0A0A0A] text-white overflow-x-hidden" data-testid="home-page">
      <Navigation />
      {isDesktop && <Ticker />}
      <Hero />
      <Calculator />
      {isDesktop && (
        <Suspense fallback={null}>
          <FundingProducts />
          <StatsSection />
          <WhyChooseUs />
          <Industries />
          <HowItWorks />
        </Suspense>
      )}
      {/* Referral promo — shown on every breakpoint because it's a
          conversion lever, not a marketing flourish. Loaded lazily
          so it doesn't block first paint. */}
      <Suspense fallback={null}>
        <ReferralRewardBanner />
      </Suspense>
      {isDesktop && (
        <Suspense fallback={null}>
          <Testimonials />
        </Suspense>
      )}
      <ApplyCTA />
      <Footer />
      {floatingsReady && (
        <Suspense fallback={null}>
          {isDesktop && <LiveNotifications />}
          <ChatWidget />
        </Suspense>
      )}
    </main>
  );
}
